module.exports = __webpack_public_path__ + "img/image32.bdc3d575.jpeg";